export default __webpack_public_path__ + "static/media/Sort1.168cbfe2.svg";